/* eslint @typescript-eslint/no-explicit-any: "off" */

import {
    getJSON as getJSONBase,
    getText as getTextBase,
    postJSON as postJSONBase,
    putJSON as putJSONBase,
    remove as removeBase,
} from "./base"
import { Receiver } from "../models/api/api"

const apiPath = "puma/api"

const addNewuiToQueryParams = (args?: any): Record<string, any> => ({
    ...args,
    newui: true,
})

const addNewuiToPath = (path: string): string =>
    `${path}${path.includes("?") ? "&" : "?"}newui=true`

export const getJSON = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> =>
    getJSONBase(
        `${apiPath}/${path}`,
        addNewuiToQueryParams(args),
        new Headers(),
        receiver,
    )

export const getText = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> =>
    getTextBase(
        `${apiPath}/${path}`,
        addNewuiToQueryParams(args),
        new Headers(),
        receiver,
    )

export const postJSON = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> =>
    postJSONBase(
        `${apiPath}/${addNewuiToPath(path)}`,
        args,
        new Headers(),
        receiver,
    )

export const putJSON = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> =>
    putJSONBase(
        `${apiPath}/${addNewuiToPath(path)}`,
        args,
        new Headers(),
        receiver,
    )

export const remove = (
    path: string,
    args?: any,
    receiver?: Receiver,
): Promise<any> =>
    removeBase(
        `${apiPath}/${addNewuiToPath(path)}`,
        args,
        new Headers(),
        receiver,
    )
